import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="bagging-section"
//
// Tells the server which Bagging section this page shows (the board, or one Lot's "Embolse" tab), and for the board
// which ISO year, on every Turbo request made inside the element, such as its sheet modal's loads and saves. A save
// then re-renders only that section, for that year. It only adds headers; the server renders the markup.
export default class extends Controller {
  static values = { id: String, year: Number }

  connect() {
    this.boundAddHeader = this.#addHeader.bind(this)
    this.element.addEventListener("turbo:before-fetch-request", this.boundAddHeader)
  }

  disconnect() {
    this.element.removeEventListener("turbo:before-fetch-request", this.boundAddHeader)
  }

  #addHeader(event) {
    const headers = event.detail.fetchOptions.headers
    headers["X-Bagging-Section"] = this.idValue
    if (this.hasYearValue) headers["X-Bagging-Year"] = String(this.yearValue)
  }
}
